import { render, staticRenderFns } from "./Other-Discontinuation-Reasons.vue?vue&type=template&id=77a8085e&scoped=true&"
import script from "./Other-Discontinuation-Reasons.vue?vue&type=script&lang=js&"
export * from "./Other-Discontinuation-Reasons.vue?vue&type=script&lang=js&"
import style0 from "./Other-Discontinuation-Reasons.vue?vue&type=style&index=0&id=77a8085e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a8085e",
  null
  
)

component.options.__file = "Other-Discontinuation-Reasons.vue"
export default component.exports